import MenuManager from '@yooink/youtils/es/MenuManager';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';

MenuManager.RegisterItem({
	key: 'Advent',
	path: '/advent',
	name: 'Advent'
});

const AdventRoute = (props) => {
	const basePath = props.path || '/advent';
	const getPath = (path = '') => `${basePath}${path}`;

	const List = useLoadComponent(() => import('./List').then((res) => res.List), {
    	basePath
    });
    const View = useLoadComponent(() => import('./View').then((res) => res.Edit), {
    	basePath
    });
    

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				
				<Route
					exact
					path={getPath('/:id')}
					component={View}
				/>
			</Switch>
		</>
	);
};

AdventRoute.propTypes = {
	path: PropTypes.string
};

export { AdventRoute };
